module.exports = __webpack_public_path__ + "static/media/21460013-J3S0wSgs.2506c69b.JPG";